import Alert from "../components/customModal/modalWrapper/customAlertModal";
import renderCustomModalFunction from "../components/customModal/modalWrapper/renderCustomModalFunction";
import performOperatorBreakRequest from "../hooks/performOperatorBreak";
import Swal from "sweetalert2";


const performOperatorBreak= async (p_relevantUrl,p_id, p_activate, p_isOnLine) => {


    const performOperatorBreakResponse = await performOperatorBreakRequest(p_relevantUrl,p_id, p_activate);
    if(performOperatorBreakResponse ==='ok'){
        Swal.fire({
            icon: 'success',
            title: 'Operator break secceed!',
            position:'center',
            confirmButtonColor:'#00A7EE'
        });
    }else{
        Swal.fire({
            icon: 'error',
            title:'Something went wrong',
            position:'center',
            confirmButtonColor:'#00A7EE',
        })
    }
 
}

export const operatorBreakFunction =async (p_relevantUrl,p_id, p_activate, p_isOnLine) =>{
   
    if(!p_isOnLine){
        Swal.fire({
            icon: 'warning',
            title:'Cart must be online !',
            position:'center',
            confirmButtonColor:'#00A7EE',

        });
        // const confirmed = await Alert({
        //     title: 'Cart must be online !',
        //     text: '',
        //     icon: 'warning', // Replace with your icon SVG code
        //     options: {
        //         confirmButtonText: 'Yes',
        //         cancelButtonText: 'No',
        //         showCancelButton: true,
        //     },
        // });
    
        return;
    }

    const msg = p_activate ? "perform" : "cancel";
    
    let active =!p_activate;
    const performOperatorBreakCallback = () => performOperatorBreak(p_relevantUrl,p_id, p_activate, p_isOnLine);
    const headerText =`Operator Break. Cart id: ${p_id}`;
    const bodyText =`Cart will  <span style="color:${active ?'var(--dark_green)' :"#FF3239"};">${msg} operator break</span>, are you sure ?`;

    const options = {
        title: headerText,
        bodyText:bodyText,
        buttons: [
            {
                text: "Cancel",
                class: "cancelButton",
                closeModal: true,
                value: "cancel"
            },
            {
                text: "Confirm",
                class: "dangerButton",
                closeModal: true,
                callback:performOperatorBreakCallback,
                value: "confirm"
            }
        ],

    };
    
    renderCustomModalFunction(options)
}   

